import ReactGA from 'react-ga4'
import { get } from 'lodash'

const TRACKING_ID = {
  DEV: 'G-C5GS0K8STS',
  PROD: 'G-NRHKCQN6K4'
}
const GROUP = 'seller'

let lastPathname = null

if (
  typeof window !== 'undefined' &&
  window.location.pathname.startsWith('/seller/')
) {
  const trackingId = window.location.hostname === 'tw.supplier.yahoo.com'
    ? TRACKING_ID.PROD
    : TRACKING_ID.DEV

  ReactGA.initialize(trackingId, {
    gtagOptions: {
      send_page_view: false
    }
  })
}

export const sendGaPv = (pageType, user = {}) => {
  if (typeof window === 'undefined') {
    return
  }

  const currentPathname = window.location.pathname
  if (currentPathname === lastPathname) {
    return
  }
  lastPathname = currentPathname

  const sellerId = get(user, 'sellerId', '')
  if (!sellerId) {
    return
  }

  ReactGA.event('page_view', {
    group: GROUP,
    page_type: pageType,
    action: `${pageType}_PV`,
    seller_id: sellerId,
    seller_name: get(user, 'sellerName', '')
  })
}

export const sendGaClick = (label, user = {}) => {
  if (typeof window === 'undefined') {
    return
  }

  const sellerId = get(user, 'sellerId', '')
  if (!sellerId) {
    return
  }

  ReactGA.event('click', {
    group: GROUP,
    page_type: 'seller_dashboard',
    action: 'seller_dashboard_click',
    label,
    seller_id: sellerId,
    seller_name: get(user, 'sellerName', '')
  })
}
